var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccomodation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 9.75C5.67525 9.75 4.5 10.9253 4.5 12.375C4.5 13.8247 5.67525 15 7.125 15C8.57475 15 9.75 13.8247 9.75 12.375C9.75 10.9253 8.57475 9.75 7.125 9.75ZM7.125 11.25C7.74525 11.25 8.25 11.7548 8.25 12.375C8.25 12.9952 7.74525 13.5 7.125 13.5C6.50475 13.5 6 12.9952 6 12.375C6 11.7548 6.50475 11.25 7.125 11.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 16.4993V11.9993H18.75C19.9905 11.9993 21 13.0088 21 14.2493V16.4993H12.75ZM18.75 10.4993H12.75C11.9227 10.4993 11.25 11.172 11.25 11.9993V16.4993H3V7.94776L12 3.10126L21.3945 8.16001L22.1055 6.83851L12.3555 1.58851C12.1342 1.47001 11.8658 1.47001 11.6445 1.58851L1.8945 6.83851C1.6515 6.96976 1.5 7.22326 1.5 7.49926V22.4993H3V17.9993H21V22.4993H22.5V14.2493C22.5 12.1815 20.8177 10.4993 18.75 10.4993Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccomodation);
export default __webpack_public_path__ + "static/media/accomodation.f6acc614f0c9fce8af514534f0602ac8.svg";
export { ForwardRef as ReactComponent };